<script>
import Filtro from "./Panel";
import { mapGetters } from "vuex";
import Slider from "./PrecioSlider";
import Placeholder from "../Placeholder/Filtros/Precio";
export default {
  components: { Filtro, Slider, Placeholder },
  computed: {
    ...mapGetters([
      "isMoneda",
      "getMoneda",
      "isPreloader",
      "getFiltroPrecioMin",
      "getFiltroPrecioMax",
    ]),
    getMonedaShow() {
      let moneda = this.getMoneda;
      if (!moneda) {
        moneda = "USD";
      }
      return moneda;
    },
  },
  methods: {
    clear() {
      this.$refs.ARS.clear();
      this.$refs.USD.clear();
      this.$refs.EUR.clear();
    },
  },
};
</script>

<template>
  <div v-if="getFiltroPrecioMin('USD') < getFiltroPrecioMax('USD')">
    <filtro
      v-if="!isPreloader"
      :heading="'Precio ' + getMonedaShow"
      icono="cash-multiple"
      :total="false"
    >
      <slider moneda="ARS" ref="ARS" v-show="getMonedaShow === 'ARS'"></slider>
      <slider moneda="USD" ref="USD" v-show="getMonedaShow === 'USD'"></slider>
      <slider moneda="EUR" ref="EUR" v-show="getMonedaShow === 'EUR'"></slider>
    </filtro>

    <placeholder v-else></placeholder>
  </div>
</template>